import { render, staticRenderFns } from "./FormNotActive.vue?vue&type=template&id=c7287dc0&scoped=true"
import script from "./FormNotActive.vue?vue&type=script&lang=js"
export * from "./FormNotActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7287dc0",
  null
  
)

export default component.exports